import { render, staticRenderFns } from "./RiskIndexFullDetail.vue?vue&type=template&id=ecfa7ad8&scoped=true"
import script from "./RiskIndexFullDetail.vue?vue&type=script&lang=js"
export * from "./RiskIndexFullDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskIndexFullDetail.vue?vue&type=style&index=0&id=ecfa7ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfa7ad8",
  null
  
)

export default component.exports